import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import ProductGridItem from '../components/ProductGridItem';
import Modal from '../components/Modal';

export default class StaticSearch {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.modal = new Modal();

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(new ProductGridItem($(productItem)));
    });

    this._updatePrices();
  }

  onSectionUnload() {
    this.modal.unload();

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }

  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }
}
